import React from "react";
import List3 from "../List3";
import styled from "styled-components";
import { InterNormalTuna18px, InterNormalWhite22px } from "../../styledMixins";


function ListOfItems11(props) {
  const { className } = props;

  return (
    <ListOfItems className={`list-of-items-49 ${className || ""}`}>
      <Text className="text-8"></Text>
      <Customizable className="customizable-1">Customizable</Customizable>
      <List3 />
      <Customizable className="customizable-2">Customizable</Customizable>
    </ListOfItems>
  );
}

const ListOfItems = styled.div`
  display: flex;
  margin-left: 6px;
  width: 268px;
  height: 165px;
  position: relative;
  margin-top: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  &.list-of-items-49.list-of-items-50 {
    margin-top: 45px;
  }

  &.list-of-items-49.list-of-items-51 {
    margin-top: 45px;
  }
`;

const Text = styled.div`
  ${InterNormalWhite22px}
  position: relative;
  width: fit-content;
  margin-top: -1px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
`;

const Customizable = styled.div`
  ${InterNormalTuna18px}
  position: relative;
  width: fit-content;
  letter-spacing: 0;
  line-height: normal;
`;

export default ListOfItems11;
